import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh', background: '#f4ede0',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'DM Sans', sans-serif", padding: '20px', textAlign: 'center',
    }}>
      <div style={{ maxWidth: '440px' }}>
        <img src="/nico-dog-face.png" alt="NICO" style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '20px', opacity: 0.8 }} />

        <h1 style={{
          fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800,
          fontSize: '72px', color: '#14562e', margin: '0 0 4px', lineHeight: 1,
          letterSpacing: '-0.03em',
        }}>404</h1>

        <h2 style={{
          fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700,
          fontSize: '22px', color: '#183d24', margin: '0 0 12px',
        }}>Ops, página não encontrada</h2>

        <p style={{ fontSize: '15px', color: '#6a7268', lineHeight: 1.6, margin: '0 0 28px' }}>
          O Nico farejou por toda parte, mas não encontrou essa página. Pode ter sido removida ou o endereço está errado.
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate('/')} style={{
            padding: '14px 28px', borderRadius: '12px', border: 'none',
            background: '#14562e', color: '#fff', fontSize: '15px', fontWeight: 700,
            cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
            boxShadow: '0 4px 16px rgba(20,86,46,.18)',
            transition: 'transform 0.15s',
          }}>
            Ir para a home
          </button>
          <button onClick={() => navigate(-1)} style={{
            padding: '14px 28px', borderRadius: '12px',
            border: '1.5px solid #e5ddc9', background: '#fff',
            color: '#183d24', fontSize: '15px', fontWeight: 600,
            cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
            transition: 'background 0.15s',
          }}>
            ← Voltar
          </button>
        </div>
      </div>
    </div>
  );
}
